import { render, staticRenderFns } from "./Inicio.vue?vue&type=template&id=c9aeeb94&scoped=true"
import script from "./Inicio.vue?vue&type=script&lang=ts"
export * from "./Inicio.vue?vue&type=script&lang=ts"
import style0 from "./Inicio.vue?vue&type=style&index=0&id=c9aeeb94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9aeeb94",
  null
  
)

export default component.exports